import React from "react";
// import PropTypes from "prop-types";
import cx from "classnames";
import { OrderedMap } from "immutable";
import { Row, Col, Card, List as AntList, Statistic } from "antd";
import { UI_LIST_ITEM_TYPES } from "constants";
import "styles/financial-analysis-table.css";

const ListItem = AntList.Item;
0;

const CREDIT_SUMMARY = new OrderedMap({
    associate_details: {
        label: "Associate Details",
        type: UI_LIST_ITEM_TYPES.SECTION
    },
    company_name: {
        label: "Business Entity Name",
        value: ""
    },
    constitution: {
        label: "Constitution",
        value: ""
    },
    associate_names: {
        label: "Propreitor/ Partner/ Director Name(s)",
        value: []
    },
    age_of_main_promoter: {
        label: "Main Borrower Age",
        value: 90
    },
    shareholding_pattern: {
        label: "Shareholding Pattern",
        value: []
    },
    business_details_and_stability: {
        label: "Business Details and Stability",
        type: UI_LIST_ITEM_TYPES.SECTION
    },
    anchor: {
        label: "Anchor Name",
        value: "New Velavan Agency"
    },
    business_vintage_with_anchor: {
        label: "Business Vintage with Anchor",
        value: "Test"
    },
    number_of_years_in_current_business: {
        label: "Number of Years in Current Business",
        value: 10
    },
    business_address: {
        label: "Business Address",
        value: ""
    },
    number_of_years_at_current_business_address: {
        label: "Number of Years at current business address",
        value: 4
    },
    number_of_offices_and_shop_premises_owned: {
        label: "Number of shop/office premises owned"
    },
    residence_address_and_stability: {
        label: "Residence Address and Stability",
        type: UI_LIST_ITEM_TYPES.SECTION
    },
    residential_address: {
        label: "Residential Address",
        value: ""
    },
    number_of_years_in_current_residence: {
        label: "Number of years at current residence",
        value: 2
    },
    residence_owned_or_rented: {
        label: "Residence owned or rented",
        value: "Owned"
    },
    limit_details: {
        label: "Limit Details",
        type: UI_LIST_ITEM_TYPES.SECTION
    },
    proposed_limit: {
        label: "Proposed Limit",
        value: 10000
    },
    product: {
        label: "Product",
        value: "LMRF"
    },
    tenure_in_days: {
        label: "Tenure(in days)",
        value: 90
    },
    return_on_investment_percent: {
        label: "ROI(%)",
        value: 20
    },
    processing_fees: {
        label: "Processing Fees",
        value: 2000
    },
    banking_summary: {
        label: "Banking Summary",
        type: UI_LIST_ITEM_TYPES.SECTION
    },
    type_of_bank_account_considered: {
        label: "Type of Bank Account considered",
        value: 1
    },
    average_bank_balance: {
        label: "Average Bank Balance",
        value: 10000
    },
    inward_return_in_last_six_months: {
        label: "Inward Return in Last Six Months",
        value: 100000
    },
    outward_return_in_last_six_months: {
        label: "Outward Return in Last Six Months",
        value: 100000
    },
    abb_limit: {
        label: "ABB::Limit",
        value: 10
    },
    limit_calculation: {
        label: "Limit Calculation",
        type: UI_LIST_ITEM_TYPES.SECTION
    },
    origination_score_and_risk: {
        label: "Origination Risk and Score",
        value: ""
    },
    average_purchase_during_trade_season: {
        label: "Average Purchase during trade season",
        value: 10000
    },
    multiplier: {
        label: "Multiplier",
        value: 1.2
    },
    max_amount_eligible: {
        label: "Max amount eligible",
        value: 1.2
    },
    amount_offered: {
        label: "Amount Offered",
        value: 12121212
    },
    remarks: {
        label: "Remarks",
        type: UI_LIST_ITEM_TYPES.SECTION
    },
    remarks_value: {
        label: "Remarks",
        value: "String Content"
    }
});

const CreditSummaryList = (
    <AntList
        bordered={true}
        itemLayout={"horizontal"}
        className={"tabulated-list"}
    >
        {CREDIT_SUMMARY.map(_ => (
            <ListItem
                key={_.label}
                className={cx({
                    "list-section": _.type === UI_LIST_ITEM_TYPES.SECTION
                })}
            >
                <ListItem.Meta title={_.label} />
                {_.value}
            </ListItem>
        ))
            .toList()
            .toArray()}
    </AntList>
);

const RISK_ANALYSIS_SCORE = new OrderedMap({
    business_risk: {
        label: "Business Risk",
        actual_score: {
            value: 100,
            suffix: 90
        },
        weighted_score: {
            value: 100,
            suffix: 90
        },
        status: "Positive"
    },
    financial_risk: {
        label: "Financial Risk",
        actual_score: {
            value: 100,
            suffix: 90
        },
        weighted_score: {
            value: 100,
            suffix: 90
        },
        status: "Positive"
    },
    total_score: {
        className: "color-blue-highlight",
        label: "Total Score",
        actual_score: {
            value: 100,
            suffix: 90
        },
        weighted_score: {
            value: 100,
            suffix: 90
        },
        status: "Positive"
    }
});

const ScoreTable = (
    <AntList className={"score-card-list"} itemLayout={"vertical"}>
        {RISK_ANALYSIS_SCORE.map(_ => (
            <ListItem key={_.label} className={_.className}>
                <ListItem.Meta title={_.label} />
                <div className={"d-flex justify-content-space-between"}>
                    <Statistic
                        title="Actual Score"
                        value={_.actual_score.value}
                        precision={2}
                        suffix={`/ ${_.actual_score.suffix}`}
                    />
                    <Statistic
                        title="Weighted Score"
                        value={_.weighted_score.value}
                        precision={2}
                    />
                </div>
            </ListItem>
        ))
            .toList()
            .toArray()}
    </AntList>
);

const AUTO_COMPUTED_RATIOS = new OrderedMap({
    year_ended: {
        label: "Year Ended",
        value: ["2018", "2019"]
    },
    ratio_debt_equity: {
        label: "Debt Equity",
        value: ["1.52", "1.63"]
    },
    ratio_tol_by_tnw: {
        label: "TOL/TNW",
        value: ["1.52", "1.63"]
    },
    ratio_current_ratio: {
        label: "Current Ratio",
        value: ["1.52", "1.63"]
    },
    ratio_net_working_capital: {
        label: "Net Working Capital",
        value: ["1.52", "1.63"]
    },
    ratio_ebitda: {
        label: "EBITDA",
        value: ["1.52", "1.63"]
    },
    ratio_ebitda_by_net_sales: {
        label: "EBITDA/Net Sales(%)",
        value: ["1.52", "1.63"]
    },
    ratio_creditor_turnover_days: {
        label: "Credit T/O days",
        value: ["1.52", "1.63"]
    },
    ratio_debtor_turnover_days: {
        label: "Debtor T/O days",
        value: ["1.52", "1.63"]
    }
});
const AutoComputedRatioList = (
    <AntList
        className={"tabulated-list"}
        itemLayout={"horizontal"}
        dataSource={AUTO_COMPUTED_RATIOS.filter((_, k) => k !== "year_ended")
            .toList()
            .toArray()}
        header={
            <ListItem key={AUTO_COMPUTED_RATIOS.first().label}>
                <ListItem.Meta title={AUTO_COMPUTED_RATIOS.first().label} />
                <div>{AUTO_COMPUTED_RATIOS.first().value.join(" | ")}</div>
            </ListItem>
        }
        renderItem={item => (
            <ListItem key={item.label}>
                <ListItem.Meta title={item.label} />
                <div>{item.value.join(" | ")}</div>
            </ListItem>
        )}
    />
);

class CreditSummary extends React.Component {
    render() {
        return (
            <Row className={"p-5"}>
                <Col span={18} className={"p-5"}>
                    {CreditSummaryList}
                </Col>
                <Col span={6} className={"p-5"}>
                    <Card className={"padless-card mb-10"}>{ScoreTable}</Card>
                    <Card className={"padless-card mb-10"}>
                        {AutoComputedRatioList}
                    </Card>
                </Col>
            </Row>
        );
    }
}

export default CreditSummary;
